<lib-question-display [question]="question.value" />
<ion-checkbox [formControl]="checkboxCtrl" />
